import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserModule } from './user/user.module';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { environment } from '@nrwl/environment';

@NgModule({
  imports: [
    CommonModule,
    UserModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot(),
  ],
  providers: [],
})
export class RootStoreModule {}
